'use client'

// lib files
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { ShowRowContent } from '@/lib/types/api/show-data';

// components
import FeaturedShowsRow from './FeaturedShowsRow';
import RecommendedShowsRow from '@/components/RecommendedShowsRow/RecommendedShowsRow';

interface TopPicksOrFeaturedShowsRowProps {
  featuredShows: ShowRowContent[];
  showMyStationBadge?: boolean;
}

const TopPicksOrFeaturedShowsRow = (props: TopPicksOrFeaturedShowsRowProps) => {
  const { featuredShows, showMyStationBadge } = props;

  return (
    <RecommendedShowsRow
      fallback={
        <FeaturedShowsRow
          shows={featuredShows}
          showMyStationBadge={showMyStationBadge}
        />
      }
      showMyStationBadge={showMyStationBadge}
      useMainRecommendedShows={true}
    data-sentry-element="RecommendedShowsRow" data-sentry-component="TopPicksOrFeaturedShowsRow" data-sentry-source-file="TopPicksOrFeaturedShowsRow.tsx" />
  );
}

export default TopPicksOrFeaturedShowsRow;
